import Image from 'next/image'
import {FC} from 'react'

import {HowItWorksStepType} from '@/components/common/how-it-works/HowItWorks'
import {theme} from '@/theme/theme'

import {Text, TextFontWeight, TextVariant} from '../../content/Text'

type HowItWorksStepProps = HowItWorksStepType & {
  isCentered?: boolean
  index?: number
}

export const HowItWorksStep: FC<React.PropsWithChildren<HowItWorksStepProps>> = ({
  title,
  duration,
  description,
  imageSrc,
  imageAlt,
  isCentered = false,
  index,
}) => {
  return (
    <>
      <div className={isCentered ? 'centered' : ''}>
        {imageSrc && imageAlt ? (
          <div className="image">
            <Image
              src={imageSrc}
              alt={imageAlt}
              width={115}
              height={64}
              style={{objectFit: 'contain', objectPosition: isCentered ? 'center' : 'left'}}
            />
          </div>
        ) : index ? (
          <div className="number">
            <Text fontWeight={TextFontWeight.bold} color={theme.palette.text.white}>
              {index}
            </Text>
          </div>
        ) : null}
        {duration && (
          <div className="duration">
            <Text
              variant={TextVariant.subtitle12}
              className="text-block"
              color={theme.palette.text.light}
              fontWeight={TextFontWeight.semibold}
            >
              {duration}
            </Text>
          </div>
        )}
        <Text variant={TextVariant.h4} element="h3">
          {title}
        </Text>
        <div className="description">
          <Text color={theme.palette.text.light}>{description}</Text>
        </div>
      </div>

      <style jsx>{`
        .image {
          position: relative;
          width: 100%;
          height: 64px;
          margin-bottom: ${theme.spacing[4]};
        }
        .duration {
          text-transform: uppercase;
          margin-top: ${theme.spacing[4]};
          margin-bottom: ${theme.spacing[2]};
        }
        .description {
          margin-top: ${theme.spacing[2.5]};
        }
        .centered {
          text-align: center;
        }
        .centered .image {
          margin-left: auto;
          margin-right: auto;
        }
        .number {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          background-color: ${theme.palette.primary.main};
          border-radius: 50%;
          counter-increment: step-counter;
          margin-bottom: ${theme.spacing[3]};
        }
      `}</style>
    </>
  )
}
